import React from 'react'
import styles from "../../../../../assets/styles/componentStyles/templatemessages.module.scss"
import carouselStyles from '../../../../../assets/styles/componentStyles/carouselCard.module.scss'
import { secondaryColor } from '../../../../../utils/colors';
import { Grid, useMediaQuery } from '@mui/material';
import Slider from 'react-slick';
import TemplatePreviewGlobal from '../../../../../components/dashboard/channels/global/whatsapp/templates/previews/templatePreviewGlobal';
import { replacingTemplateMarkdownText } from '../../../../../utils/constants';
import { subButtonTypeIconMap } from '../../../../../components/dashboard/templatelibrary/constant';

interface CarouselTemplatePreviewInboxProps {
    actionData: any, 
    justifyContent: string,
} 

const CarouselTemplatePreviewInbox: React.FC<CarouselTemplatePreviewInboxProps> = (props) => {

    const { actionData, justifyContent } = props;

    const isScreenBelow1000 = useMediaQuery('(max-width : 1200px) and (min-width: 0px)');

    const onClickOfArrows = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, onClick: any) => {
        e.stopPropagation();
        if(typeof onClick == "function"){
            onClick();
        } 
    }

    function SampleNextArrow(props: any) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{
                    ...style,
                    display: "flex",
                    // background: '#F3F5F9',
                    background: secondaryColor,
                    padding: '3px 3px 2px',
                    borderRadius: '50%',
                    boxShadow: "0px 0px 3px rgba(0,0,0,0.25)"
                    // '--user-msg-bg-color': chatBotDetail?.chatbot_theme?.user_msg_bg_color || '#F3F5F9'
                }}
                onClick={(e) => onClickOfArrows(e, onClick)}
            />
        );
    }

    function SamplePrevArrow(props: any) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{
                    ...style,
                    display: "block",
                    padding: '3px 3px 1px',
                    borderRadius: '50%',
                    background: secondaryColor,
                    boxShadow: "0px 0px 3px rgba(0,0,0,0.25)"
                }}

                onClick={(e) => onClickOfArrows(e, onClick)}
            />
        );
    }

    const messageText = (type: string, variation?: any) => {
        let template: string = "";
        switch(type.toLowerCase()){
            case 'globalheader': 
                template = actionData?.wa_header_text || "";
                break;
            case 'header': 
                template = variation?.whatsapp_header_text || "";
                break;
            case 'body': 
                template = variation?.whatsapp_body_text || "";
                break;
            case 'footer':
                template = variation?.whatsapp_footer_text || "";
                break;
            default:
                return "";
        }
        return replacingTemplateMarkdownText(template);
    } 

    const getSubButtonText = (btn: any) => {
        let fieldVal = btn?.button_fields?.filter((field: any) => field.field_name?.toLowerCase() == "button text")[0];
        return fieldVal?.whatsapp_template_button_sub_type_field_value || "";
    }

    return (
        <>
            <Grid item style={{ padding: "0px 25px 0px 25px" }}>
                <Grid container justifyContent={justifyContent} alignItems={"end"}>
                    <Grid item>
                        <div className={carouselStyles.slider_container} style={{ maxWidth: "300px" }}>
                            <Slider
                                swipe={isScreenBelow1000 ? true : false}
                                arrows={true}
                                dots={false}
                                infinite={false}
                                autoplay={false}
                                variableWidth={true}
                                className={carouselStyles.chatbot_click_slider_template}
                                slidesToShow={1}
                                slidesToScroll={1}
                                nextArrow={<SampleNextArrow className={carouselStyles.chat_slider_next_arrow} />}
                                prevArrow={<SamplePrevArrow className={carouselStyles.chat_slider_prev_arrow} />}
                            // speed={400}
                            >
                                {actionData?.wa_carousel_variations?.map((variation: any) => {
                                    return (
                                        <Grid item className={styles.previewSectionCardBlock}>
                                            <Grid container direction={"column"} flexWrap={"nowrap"}>
                                                <TemplatePreviewGlobal
                                                    headerType={variation.whatsapp_template_header_type_name || "image"}
                                                    headerURL={variation?.whatsapp_header_media_chronox_storage_url || ""}
                                                    headerVaraibleData={[]}
                                                    isFooter={variation?.whatsapp_footer_text && variation?.whatsapp_footer_text?.length > 0}
                                                    headerText={messageText("header", variation)}
                                                    bodyText={messageText("body", variation)}
                                                    footerText={messageText("footer", variation)}
                                                />
                                                {
                                                    variation?.buttons && variation?.buttons?.length > 0 && 
                                                    variation?.buttons?.map((btn: any, index: number) => {
                                                        return (
                                                            <Grid item key={index} paddingBlock={"12px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                                                                <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                                                    <Grid item>
                                                                        {subButtonTypeIconMap[btn?.whatsapp_template_button_sub_type_name?.toLowerCase() as keyof typeof subButtonTypeIconMap]}
                                                                    </Grid>
                                                                    <Grid item>
                                                                        {getSubButtonText(btn)}
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        );
                                                    })
                                                }
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                            </Slider>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CarouselTemplatePreviewInbox
